(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["flery-featured-brand-editorial"] && !Shopify.designMode) return;
  try {
    const miaCaraFeature = document.getElementById('flery-brand-feature');
  const miaCaraFilm = miaCaraFeature.querySelector('.brand-edit-film');
  const miaCaraLead = miaCaraFeature.querySelector('.brand-edit-lead');
  const miaCaraButton = miaCaraFeature.querySelector('.brand-edit-cta');
  const miaCaraCompact = window.matchMedia('(max-width: 1024px)');
  function positionMiaCaraFilm() {
    if (miaCaraCompact.matches) {
      miaCaraButton.before(miaCaraFilm);
    } else {
      miaCaraLead.append(miaCaraFilm);
    }
  }
  positionMiaCaraFilm();
  miaCaraCompact.addEventListener('change', positionMiaCaraFilm);
  } catch(e) { console.error(e); }
})();

})();
